export default __webpack_public_path__ + "static/discover-templates-5f065b5522816faf492055dacc3c6d23.png";